// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__BTLHv","searchIcon":"SearchInput_searchIcon__LAreT"};